'use es6';

import { ALLOWED_FILE_TYPES } from 'conversations-internal-schema/file-metadata/constants/allowedFileTypes';
import PropTypes from 'prop-types';
import VizExLink from 'visitor-ui-component-library/link/VizExLink';
import VizExFileButton from 'visitor-ui-component-library/button/VizExFileButton';
import { jsx as _jsx } from "react/jsx-runtime";
const FilePickerLink = props => {
  return /*#__PURE__*/_jsx(VizExFileButton, {
    accept: ALLOWED_FILE_TYPES,
    use: "unstyled",
    onClick: props.onClick,
    onChange: props.onChange,
    children: buttonProps => /*#__PURE__*/_jsx(VizExLink, Object.assign({
      use: "on-bright"
    }, buttonProps, {
      children: props.children
    }))
  });
};
FilePickerLink.displayName = 'FilePickerLink';
FilePickerLink.propTypes = {
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func
};
export default FilePickerLink;